import { render } from "./ShozeSec.vue?vue&type=template&id=001b4f9a&scoped=true"
import script from "./ShozeSec.vue?vue&type=script&lang=js"
export * from "./ShozeSec.vue?vue&type=script&lang=js"

import "./ShozeSec.vue?vue&type=style&index=0&id=001b4f9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001b4f9a"]])

export default __exports__